import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, ASSETS } from "@/lib/site";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative scroll-mt-nav py-28 md:py-36 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${ASSETS.earthMoon})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/85 to-black" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.3em] uppercase text-[#2DD4BF] mb-6">06 · Reach the House</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-white">
            Bangalore based. <span className="italic text-gradient-gold">Open to the world.</span>
          </h2>
          <p className="text-slate-300 mt-6 text-lg">
            Casting calls, collaborations, distribution, press — write, call, or visit the studio.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mt-16 max-w-5xl mx-auto">
          <a
            href={`tel:${SITE.phone}`}
            data-testid="contact-phone-card"
            className="glass-card rounded-2xl p-8 hover-lift block"
          >
            <Phone size={22} strokeWidth={1.5} className="text-[#2DD4BF]" />
            <p className="text-xs tracking-[0.25em] uppercase text-slate-400 mt-4">Phone</p>
            <p className="font-serif text-2xl text-white mt-2">{SITE.phoneDisplay}</p>
            <p className="text-slate-500 text-sm mt-2">Mon — Sat · 10am to 8pm IST</p>
          </a>

          <a
            href={`mailto:${SITE.email}`}
            data-testid="contact-email-card"
            className="glass-card rounded-2xl p-8 hover-lift block"
          >
            <Mail size={22} strokeWidth={1.5} className="text-[#2DD4BF]" />
            <p className="text-xs tracking-[0.25em] uppercase text-slate-400 mt-4">Email</p>
            <p className="font-serif text-2xl text-white mt-2 break-all">{SITE.email}</p>
            <p className="text-slate-500 text-sm mt-2">Replies within 48 hours</p>
          </a>

          <div className="glass-card rounded-2xl p-8 hover-lift" data-testid="contact-address-card">
            <MapPin size={22} strokeWidth={1.5} className="text-[#2DD4BF]" />
            <p className="text-xs tracking-[0.25em] uppercase text-slate-400 mt-4">Studio</p>
            <p className="font-serif text-lg text-white mt-2 leading-snug">
              {SITE.address.line1}<br />
              {SITE.address.line2}<br />
              {SITE.address.line3}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
